<div  style="display:flex; flex-flow:row">
  <div class="header-logo-wrapper">
    <div class="logo-wrapper">
      <a routerLink="/">
        <img class="img-fluid for-light" style="height:80px;"
             src="https://www.egishe.bg/img/logo_text.png"
             alt="" /><img class="img-fluid for-dark"
                           src="https://www.egishe.bg/img/logo_text.png"
                           alt="" />
      </a>
    </div>
    </div>
  <div > 
  </div> 
</div>
